// extracted by mini-css-extract-plugin
module.exports = {"container":"my-utmb-label_container__1HfRF","plus":"my-utmb-label_plus__ooCr7"};